import { render } from "./VerticalStep.vue?vue&type=template&id=76653071"
import script from "./VerticalStep.vue?vue&type=script&lang=js"
export * from "./VerticalStep.vue?vue&type=script&lang=js"
script.render = render

export default script